export const DashboradIcon = require("../assets/image_r (1).png");
export const Dropdown = require("../assets/dropdown_logo.svg");
export const PatientsIcon = require("../assets/image_r (2).png");
export const headerAvtar = require("../assets/headerUser.svg");
export const headerLogo =  require("../assets/image_logo.png");
export const Milestone =  require("../assets/milestone.svg");
export const sideImage =  require("../assets/sideImage.svg");
export const progressSide =  require("../assets/progress.svg");